import { asyncScheduler, defer, fromEvent, map, merge, mergeMap, Observable, of, scheduled } from 'rxjs';
import { Action } from 'redux';

import { RuntimeActions, RuntimeMsg } from '../runtime.register';

export function onlineOffLineEpic(_actions, _state, deps: { window$: Observable<Window> }): Observable<Action> {
    return deps.window$.pipe(
        mergeMap((win: Window) => {
            const online = fromEvent(win, 'online').pipe(map(() => true));
            const offline = fromEvent(win, 'offline').pipe(map(() => false));
            const first = defer(() => scheduled(of(win.navigator.onLine), asyncScheduler));

            return merge(online, offline, first).pipe(map((online) => RuntimeMsg(RuntimeActions.SetOnline, online)));
        }),
    );
}
